import { normalizeAttributeValue } from './normalizeAttributeValue';
export const normalizeAttributeNameValue = (attrDef, attrValue) => {
    const { id, name } = attrDef;
    return {
        id,
        name: name || id,
        value: normalizeAttributeValue(attrValue),
    };
};
//# sourceMappingURL=normalizeAttributeNameValue.js.map